/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidationError } from '../../models/validation-error';

export interface AssignUser$Params {
  id: string;
  'user-id': string;

/**
 * if resource is assigned to different user force flag should be true to override it
 */
  isForce?: boolean;
}

export function assignUser(http: HttpClient, rootUrl: string, params: AssignUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
  const rb = new RequestBuilder(rootUrl, assignUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('user-id', params['user-id'], {});
    rb.query('isForce', params.isForce, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationError>>;
    })
  );
}

assignUser.PATH = '/api/agn-resources/{id}/assign-user/{user-id}';
